/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Automix_TitleInputs */

const en_audio_description_export_automix_title = /** @type {(inputs: Audio_Description_Export_Automix_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automix Settings`)
};

const fr_audio_description_export_automix_title = /** @type {(inputs: Audio_Description_Export_Automix_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paramètres d'automixage`)
};

const de_audio_description_export_automix_title = /** @type {(inputs: Audio_Description_Export_Automix_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automix-Einstellungen`)
};

const it_audio_description_export_automix_title = /** @type {(inputs: Audio_Description_Export_Automix_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni di Automix`)
};

const ru_audio_description_export_automix_title = /** @type {(inputs: Audio_Description_Export_Automix_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройки автомикса`)
};

const es_audio_description_export_automix_title = /** @type {(inputs: Audio_Description_Export_Automix_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración de mezcla automática`)
};

const zh_cn2_audio_description_export_automix_title = /** @type {(inputs: Audio_Description_Export_Automix_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动混合设置`)
};

const ja_audio_description_export_automix_title = /** @type {(inputs: Audio_Description_Export_Automix_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オートミックス設定`)
};

const hi_audio_description_export_automix_title = /** @type {(inputs: Audio_Description_Export_Automix_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑटोमिक्स सेटिंग्स`)
};

const pt_pt2_audio_description_export_automix_title = /** @type {(inputs: Audio_Description_Export_Automix_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurações de automixagem`)
};

/**
* | output |
* | --- |
* | "Automix Settings" |
*
* @param {Audio_Description_Export_Automix_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_automix_title = /** @type {((inputs?: Audio_Description_Export_Automix_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Automix_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_automix_title(inputs)
	if (locale === "de") return de_audio_description_export_automix_title(inputs)
	if (locale === "it") return it_audio_description_export_automix_title(inputs)
	if (locale === "ru") return ru_audio_description_export_automix_title(inputs)
	if (locale === "es") return es_audio_description_export_automix_title(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_automix_title(inputs)
	if (locale === "ja") return ja_audio_description_export_automix_title(inputs)
	if (locale === "hi") return hi_audio_description_export_automix_title(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_automix_title(inputs)
	return en_audio_description_export_automix_title(inputs)
});